import React, { useEffect, useState } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { format } from 'date-fns';

const DepositMaturity = ({ policyno }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        const fetchReport = async () => {
            try {
                if (!policyno) {
                    console.warn("Poicy no is missing, skipping API call.");
                    return;
                }

                // const formattedDateFrom = new Date(dateFrom).toISOString().split("T")[0];
                // const formattedDateTo = new Date(dateTo).toISOString().split("T")[0];
 
                const apiUrl = `${process.env.REACT_APP_API_PATH}loan/maturity?policyno=${policyno}`;

                const response = await fetch(apiUrl, {
                    headers: { Accept: 'application/pdf' },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const blob = await response.blob();
                const pdfBlob = new Blob([blob], { type: 'application/pdf' });
                const url = URL.createObjectURL(pdfBlob);
                setPdfUrl(url);
            } catch (error) {
                console.error('Error fetching the report:', error);
            }
        };

        fetchReport();
    }, [policyno]);

    useEffect(() => {
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
        };
    }, [pdfUrl]);

    return (
        <Worker workerUrl="//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
            <div
                style={{
                    height: '750px',
                    width: '900px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}
            >
                {pdfUrl ? (
                    <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                ) : (
                    <p>Loading PDF...</p>
                )}
            </div>
        </Worker>
    );
};

export default DepositMaturity;
